import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "image-text" }
const _hoisted_2 = { class: "p-grid p-fluid" }
const _hoisted_3 = { class: "p-col-12 p-md-4" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Beden Seti Adı")
], -1)
const _hoisted_5 = { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }
const _hoisted_6 = { class: "required" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-exclamation-circle ms-2 fs-7",
  "data-bs-toggle": "tooltip",
  title: "Specify a card holder's name"
}, null, -1)
const _hoisted_9 = { style: {"float":"left","width":"90%"} }
const _hoisted_10 = ["onClick"]

import { defineComponent, ref, computed } from "vue";
import { useStore } from "vuex";
import { Actions } from "@/store/enums/StoreEnums";
import Swal from "sweetalert2/dist/sweetalert2.js";
import Modal from "@/components/Modal.vue";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import { useToast } from "primevue/usetoast";
import { Field } from "vee-validate";
import Dropdown from "primevue/dropdown";
import JwtService from "@/core/services/JwtService";

export default /*#__PURE__*/_defineComponent({
  __name: 'SizeSetList',
  setup(__props) {

const toast = useToast();
const submitButton = ref<HTMLElement | null>(null);
const store = useStore();
const isActive = ref(false);
const selectedSizeSet = ref();
const sizeSetName: any = ref();
const sizes: any = ref();
const sizeSetId: any = ref();

// Durum filtreleme seçenekleri
const statusOptions = ref([
  { label: "Aktif", value: true },
  { label: "Pasif", value: false },
]);

const toggleModal = () => {
  isActive.value = !isActive.value;
  sizeSetName.value = selectedSizeSet.value.name;
  sizeSetId.value = selectedSizeSet.value.id;
  sizes.value = selectedSizeSet.value.sizes;
};
var sizeSetList = computed(() => store.state.SizeModule.sizeSet.value || []);
const saveChanges = () => {
  store.dispatch(Actions.ADD_BODY_CLASSNAME, "page-loading");

  var model = {
    id: sizeSetId.value,
    name: sizeSetName.value,
    sizes: sizes.value,
  };
  store.dispatch(Actions.UPDATE_SIZE_SET, model).then((x) => {
    if (x.success) {
      toast.add({
        severity: "success",
        summary: "İşlem Sonucu",
        detail: x.message,
        life: 3000,
      });
      store.dispatch(Actions.SIZE_SET_LIST).then((f) => {
        store.dispatch(Actions.SIZE_SET_LIST).then((f) => {
          toast.add({
            severity: "success",
            summary: "İşlem Sonucu",
            detail: x.message,
            life: 3000,
          });
          sizes.value = f.value.find(
            (x) => x.id == selectedSizeSet.value.id
          ).sizes;
          store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
        });
      });
    } else {
      toast.add({
        severity: "error",
        summary: "İşlem Sonucu",
        detail: x.message,
        life: 3000,
      });
    }
    store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
  });
};
const filters = ref({
  global: { value: null, matchMode: FilterMatchMode.CONTAINS },
  name: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  isActive: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
  },
});

const onRowSelect = (event) => {
  toggleModal();
};

const remove = (args) => {
  Swal.fire({
    title: "İlgili kayıt silinsin mi?",
    text: "Emin misiniz? Bu işlemi geri alamazsınız!",
    type: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    confirmButtonText: "Evet, Sil!",
    cancelButtonText: "İptal",
  }).then((result) => {
    // <--
    if (result.value) {
      // <-- if confirmed
      store.dispatch(Actions.ADD_BODY_CLASSNAME, "page-loading");
      store
        .dispatch(Actions.REMOVE_SIZE_SET, args.id)
        .then((x) => {
          store.dispatch(Actions.SIZE_SET_LIST).then((f) => {
            toast.add({
              severity: "success",
              summary: "İşlem Sonucu",
              detail: x.message,
              life: 3000,
            });

            store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
          });
        })
        .catch((e) => {
          store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
        });
    }
  });
};
const removeSizeSet = (args, index) => {
  if (!args.id) {
    removeSize(args, index);
    return;
  }
  store.dispatch(Actions.ADD_BODY_CLASSNAME, "page-loading");
  store
    .dispatch(Actions.REMOVE_SIZE, args.id)
    .then((x) => {
      store.dispatch(Actions.SIZE_SET_LIST).then((f) => {
        toast.add({
          severity: "success",
          summary: "İşlem Sonucu",
          detail: x.message,
          life: 3000,
        });
        sizes.value = f.value.find(
          (x) => x.id == selectedSizeSet.value.id
        ).sizes;
        store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
      });
    })
    .catch((e) => {
      store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
    });
};

const addExperience = () => {
  sizes.value.push({
    name: "",
  });
  setTimeout(() => {
    document
      .getElementsByName("sizeName-" + (sizes.value.length - 1))[0]
      .focus();
  }, 100);
};

const removeSize = (e, index) => {
  if (sizes.value.length > 1) {
    sizes.value.splice(index, 1);
  }
};

const selectedUp = (event) => {
  const next = event.target.getAttribute("sizeName");
  let index = parseInt(next) - 1;
  if (event.keyCode == 38) {
    const element = document.getElementsByName(
      "sizeName-" + index
    )[0] as HTMLInputElement;
    if (element) {
      element.select();
      element.focus();
    }
  }
};
const selectedDown = (event) => {
  const next = event.target.getAttribute("sizeName");
  let index = parseInt(next) + 1;
  if (event.keyCode == 40) {
    const element = document.getElementsByName(
      "sizeName-" + index
    )[0] as HTMLInputElement;
    if (element) {
      element.select();
      element.focus();
    }
  }
};

return (_ctx: any,_cache: any) => {
  const _component_Column = _resolveComponent("Column")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_DataTable, {
      removableSort: "",
      showGridlines: "",
      value: _unref(store).state.SizeModule.sizeSet.value,
      responsiveLayout: "scroll",
      selection: selectedSizeSet.value,
      "onUpdate:selection": _cache[0] || (_cache[0] = ($event: any) => ((selectedSizeSet).value = $event)),
      selectionMode: "single",
      filters: filters.value,
      "onUpdate:filters": _cache[1] || (_cache[1] = ($event: any) => ((filters).value = $event)),
      filterDisplay: "menu",
      dataKey: "id",
      globalFilterFields: [
      'name',
      'country.name',
      'representative.name',
      'status',
    ],
      paginator: true,
      rows: 50,
      metaKeySelection: false,
      onRowSelect: onRowSelect
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Column, {
          selectionMode: "multiple",
          headerStyle: "width: 3em"
        }),
        _createVNode(_component_Column, {
          field: "name",
          header: "Beden Seti Adı",
          sortable: "",
          filterMatchMode: "contains",
          style: {"min-width":"10rem"}
        }, {
          body: _withCtx(({ data }) => [
            _createElementVNode("span", _hoisted_1, _toDisplayString(data.name), 1)
          ]),
          filter: _withCtx(({ filterModel }) => [
            _createVNode(_component_InputText, {
              type: "text",
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
              class: "p-column-filter",
              placeholder: "Beden Setinde"
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "isActive",
          header: "Durum",
          sortable: "",
          style: {"min-width":"8rem"}
        }, {
          body: _withCtx(({ data }) => [
            _createElementVNode("span", {
              class: _normalizeClass(["badge", data.isActive ? 'badge-success' : 'badge-danger'])
            }, _toDisplayString(data.isActive ? "Aktif" : "Pasif"), 3)
          ]),
          filter: _withCtx(({ filterModel }) => [
            _createVNode(_unref(Dropdown), {
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
              options: statusOptions.value,
              placeholder: "Durum Seçin",
              class: "p-column-filter",
              showClear: ""
            }, {
              option: _withCtx((slotProps) => [
                _createElementVNode("span", {
                  class: _normalizeClass(["badge", slotProps.option.value ? 'badge-success' : 'badge-danger'])
                }, _toDisplayString(slotProps.option.label), 3)
              ]),
              _: 2
            }, 1032, ["modelValue", "onUpdate:modelValue", "options"])
          ]),
          _: 1
        }),
        (JSON.parse(_unref(JwtService).getUser()).roles.find((x) => x.id != 2))
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 0,
              exportable: false,
              style: {"min-width":"8rem"},
              header: "İşlemler"
            }, {
              body: _withCtx((slotProps) => [
                _createVNode(_component_Button, {
                  icon: "pi pi-trash",
                  class: "p-button-rounded p-button-danger",
                  onClick: ($event: any) => (remove(slotProps.data))
                }, null, 8, ["onClick"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["value", "selection", "filters", "globalFilterFields"]),
    _createVNode(Modal, {
      onClose: toggleModal,
      modalActive: isActive.value,
      title: "Beden Seti Güncelle",
      width: "75vw"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: "Güncelle",
          type: "button",
          onClick: _cache[8] || (_cache[8] = ($event: any) => (saveChanges())),
          icon: "pi pi-check",
          autofocus: ""
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createVNode(_unref(Field), {
              type: "text",
              class: "form-control form-control-solid",
              placeholder: "",
              name: "sizeSetName",
              modelValue: sizeSetName.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((sizeSetName).value = $event)),
              onKeyup: [
                _cache[3] || (_cache[3] = _withKeys(($event: any) => (addExperience()), ["enter"])),
                _cache[4] || (_cache[4] = _withKeys(($event: any) => (selectedUp($event)), ["up"]))
              ]
            }, null, 8, ["modelValue"])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sizes.value, (experience, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "p-col-12 p-md-4",
              key: index
            }, [
              _createElementVNode("label", _hoisted_5, [
                _createElementVNode("span", _hoisted_6, [
                  _createTextVNode(" Beden "),
                  (index > 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(index + 1), 1))
                    : _createCommentVNode("", true)
                ]),
                _hoisted_8
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_unref(Field), {
                  type: "text",
                  class: "form-control form-control-solid",
                  placeholder: "Beden Adı",
                  id: `sizeName[${index}]`,
                  name: 'sizeName-' + index,
                  ref_for: true,
                  ref: `sizeName[${index}]`,
                  sizeName: index,
                  onKeyup: [
                    _cache[5] || (_cache[5] = _withKeys(($event: any) => (addExperience()), ["enter"])),
                    _cache[6] || (_cache[6] = _withKeys(($event: any) => (selectedUp($event)), ["up"])),
                    _cache[7] || (_cache[7] = _withKeys(($event: any) => (selectedDown($event)), ["down"]))
                  ],
                  modelValue: experience.name,
                  "onUpdate:modelValue": ($event: any) => ((experience.name) = $event)
                }, null, 8, ["id", "name", "sizeName", "modelValue", "onUpdate:modelValue"])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("i", {
                  class: "bi bi-x",
                  "data-bs-toggle": "tooltip",
                  style: {"font-size":"25px","color":"red","cursor":"pointer"},
                  onClick: ($event: any) => (removeSizeSet(experience, index))
                }, null, 8, _hoisted_10)
              ])
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["modalActive"])
  ], 64))
}
}

})